module.exports = __webpack_public_path__ + "static/media/1022915.39728539.png";